export const strings = {
  conversation_title: 'Mesajlarda Ara',
  no_message: 'Henüz Mesajınız Yok mu?',
  no_data: 'Bu, konuşmalarınızın başlangıcı gibi görünüyor',
  start_conversation: 'Bir Konuşma Başlat',
  search_messages: 'Mesajlarda Ara',
  inbox: 'Gelen Kutusu',
  important: 'Önemli',
  archived: 'Arşivlendi',
  new_message: 'Yeni Mesaj',
  add_more_people: 'Bir veya daha fazla kişi ekleme',
  say_something: 'Bir şeyler söyle...',
  upload_photo: 'Bir fotoğraf yükle',
  upload_video: 'Bir video yükle',
  attach_file: 'Dosya ekleme',
  send: 'Gönder',
  add_group_title: 'Grup konuşması başlığı ekleme (İsteğe bağlı)',
  mark_as_important: 'Önemli Olarak İşaretle',
  archive_conversation: 'Konuşmayı Arşivle',
  unmark_as_important: 'Önemli İşaretini Kaldır',
  unarchive_conversation: 'Konuşmayı Arşivden Çıkar',
  delete_conversation: 'Konuşmayı Sil',
  add_participants: 'Katılımcı Ekle',
  leave_conversation: 'Konuşmadan Ayrıl',
  group_conversation_title: 'Grup Konuşması Başlığı',
  no_conversations: 'Konuşma Yok',
  no_client_conversation:
    'Konuşmada sadece bir tanesisiniz. İletiyi gönderemezsiniz',
  are_you_sure_delete: 'Bu konuşmayı silmek istediğinizden emin misiniz?',
  are_you_sure_leave: 'Bu konuşmadan ayrılmak istediğinizden emin misiniz?',
};
